import { FC } from "react";
import { Link, LinkProps } from "react-router-dom";

/**
 * Router link with stopped propagation
 * @param props
 * @returns
 */
export const XmLink: FC<LinkProps> = props => <Link onClick={e => e.stopPropagation()} {...props} />